// Minimal API client for the landing app.
// Configure via env: REACT_APP_API_URL (e.g. https://your-backend.vercel.app)

const trimTrailingSlash = (s) => String(s || '').replace(/\/+$/, '');

export const API_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_API_URL || 'http://localhost:5000'
);

export const buildApiUrl = (path) => {
  const p = String(path || '');
  if (p.startsWith('http://') || p.startsWith('https://')) return p;
  return `${API_BASE_URL}${p.startsWith('/') ? '' : '/'}${p}`;
};

export const fetchJson = async (path, { signal, headers, ...rest } = {}) => {
  const res = await fetch(buildApiUrl(path), {
    signal,
    headers: {
      'Accept': 'application/json',
      ...(headers || {})
    },
    ...rest
  });

  const data = await res.json().catch(() => null);

  if (!res.ok) {
    const message = data?.message || `Request failed: ${res.status} ${res.statusText}`;
    const err = new Error(message);
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
};

export const getCityHighlights = async (city, { signal } = {}) => {
  const params = new URLSearchParams({ city: String(city || '') });
  const res = await fetchJson(`/api/city-highlights?${params.toString()}`, { signal });
  // shape: { success: true, data: {...} }
  return res?.data;
};
